import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(
    private toastService: ToastService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  handleError(error: HttpErrorResponse, context: string = 'API Request'): void {
    console.error(`${context} Error:`, error);

    // Only show user-facing errors in browser environment
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    let errorMessage = 'An unexpected error occurred.';

    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Client Error: ${error.error.message}`;
    } else {
      // Server-side error
      switch (error.status) {
        case 0:
          errorMessage = 'Network error. Please check your internet connection.';
          break;
        case 400:
          errorMessage = 'Bad request. Please check your input.';
          break;
        case 401:
          errorMessage = 'Unauthorized. Please log in again.';
          break;
        case 403:
          errorMessage = 'Access denied. You don\'t have permission for this action.';
          break;
        case 404:
          errorMessage = 'Resource not found.';
          break;
        case 500:
          errorMessage = 'Server error. Please try again later.';
          break;
        case 502:
          errorMessage = 'Bad gateway. Please try again later.';
          break;
        case 503:
          errorMessage = 'Service unavailable. Please try again later.';
          break;
        default:
          errorMessage = `Server error (${error.status}): ${error.message}`;
      }
    }

    // Show error toast
    this.toastService.error(errorMessage);
  }

  isNetworkError(error: HttpErrorResponse): boolean {
    return error.status === 0 || error.status === 502 || error.status === 503;
  }

  isAuthError(error: HttpErrorResponse): boolean {
    return error.status === 401 || error.status === 403;
  }

  isServerError(error: HttpErrorResponse): boolean {
    return error.status >= 500;
  }

  isClientError(error: HttpErrorResponse): boolean {
    return error.status >= 400 && error.status < 500;
  }
} 